export { SmartBanner } from "./smart-banner";
export type { SmartBannerProps } from "./smart-banner";

export { ConfluenceSmartBanner } from "./confluence-smart-banner";
export type { ConfluenceSmartBannerProps } from "./confluence-smart-banner";
